import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadBoxComponent } from './file-upload-box.component';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { FileSharingService } from 'shared/services/file-share/file-sharing.service';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild()
  ],
  providers: [
    FileSharingService
  ],
  declarations: [
    FileUploadBoxComponent
  ],
  exports: [
    FileUploadBoxComponent
  ]
})
export class FileUploadBoxModule {}
